/**
 * Block: staff
 *
 * Accordion list of board members. Each person row has a trigger button
 * that toggles the visibility of the person's photo + description.
 */

function toggleTrigger(trigger) {
    const person = trigger.closest('.staff__person');
    if (!person) return;
    const content = person.querySelector('.staff__content');
    if (!content) return;

    const isOpen = content.classList.contains('staff__content--show');
    if (isOpen) {
        trigger.classList.remove('staff__trigger--up');
        trigger.classList.add('staff__trigger--down');
        content.classList.remove('staff__content--show');
        content.classList.add('staff__content--hidden');
    } else {
        trigger.classList.remove('staff__trigger--down');
        trigger.classList.add('staff__trigger--up');
        content.classList.remove('staff__content--hidden');
        content.classList.add('staff__content--show');
    }
}

export function init() {
    const triggers = document.querySelectorAll('.staff__trigger');
    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => toggleTrigger(trigger));
    });
}
